import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex gap-[0.15rem]" }
const _hoisted_2 = { class: "min-w-40 bg-white p-4" }
const _hoisted_3 = { class: "title t4 -mt_0 -mb_1" }

import { useAttrs, computed } from 'vue'
import { $http } from '@/plugins'


export default /*@__PURE__*/_defineComponent({
  __name: 'PatientAttentionLevel',
  props: {
    disabled: { type: Boolean, default: false },
    value: { default: '' }
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const levels = [
  {
    size: 3,
    optLabel: 'COMMON.HIGH',
    optValue: 'high',
    color: 'bg-negative-600',
  },
  {
    size: 2,
    optLabel: 'COMMON.LOW',
    optValue: 'low',
    color: 'bg-warning-600',
  },
  {
    size: 1,
    optLabel: 'COMMON.VERY_LOW',
    optValue: 'very_low',
    color: 'bg-positive-800',
  },
]

const selectedLevel = computed(() => levels.find((l) => l.optValue === props.value))

const attrs = useAttrs()

const handleChangeLevel = (level: string) => {
  const patientId = attrs['patient-id']
  const body = { attention_level: level, origin: 'clinical_portal' }

  $http('patient/profile/setAttentionLevel', patientId, { body })
  emit('input', level)
}

return (_ctx: any,_cache: any) => {
  const _component_sword_radio_group_wuk = _resolveComponent("sword-radio-group-wuk")!
  const _component_sword_popover_wuk = _resolveComponent("sword-popover-wuk")!

  return (_openBlock(), _createBlock(_component_sword_popover_wuk, null, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.$t("patients_funnel_mal")), 1),
        _createVNode(_component_sword_radio_group_wuk, {
          checked: __props.value || '',
          options: levels,
          "fill-bg": "",
          "hide-errors": "",
          variant: "minimal",
          style: { '--wuk-radio-box-size-wuk': '1.4rem' },
          onChange: handleChangeLevel
        }, null, 8, ["checked"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from({length: levels.length}), (_, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: _normalizeClass(["size-[0.6rem] rounded-[0.1875rem]", [(selectedLevel.value && selectedLevel.value.size > index) ? selectedLevel.value.color : 'bg-gray-300']])
          }, null, 2))
        }), 128))
      ])
    ], undefined, true),
    _: 1
  }))
}
}

})